export const calculateFlux = (currentTotal: number, lastTotal: number) => {
  const variance = currentTotal - lastTotal;
  const variancePercent = lastTotal > 0 ? (variance / lastTotal) * 100 : 0;
  return {
    variance,
    variancePercent,
    isIncrease: variance >= 0,
    status: variancePercent >= 25 ? 'High Positive Flux' : variancePercent <= -25 ? 'High Negative Flux' : 'Stable'
  };
};

export const calculateIRSShortfall = (grossReceipts: number, reportedTips: number) => {
  const threshold = grossReceipts * 0.08;
  const shortfall = Math.max(0, threshold - reportedTips);
  return {
    threshold,
    shortfall,
    isShortfall: shortfall > 0
  };
};
